export default __webpack_public_path__ + "static/media/guc_logo.765ee59d.png";